import React from "react";
import Projects from "../components/singleProjects";


const ProjetsPage = () => {

  return (
    <section className="ProjectContainer">
    <Projects />
  </section>
  );
};

export default ProjetsPage;